import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import GtmshPrivacy from "./pages/GtmshPrivacy";
import GtmshTerms from "./pages/GtmshTerms";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function GTMVirtualPageview() {
  const location = useLocation();
  const prevUrlRef = useRef(window.location.href);

  useEffect(() => {
    const pageUrl = window.location.href;
    const pageTitle = document.title;
    const previousUrl = prevUrlRef.current;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtualPageview",
      pageUrl,
      pageTitle,
      previousUrl,
    });
    prevUrlRef.current = pageUrl;
  }, [location]);

  return null;
}

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <GTMVirtualPageview />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/gtmsh-privacy" element={<GtmshPrivacy />} />
            <Route path="/gtmsh-terms" element={<GtmshTerms />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
